import { get } from "@/utils/utils";

// 判断单个竞猜是否过期
export function isGuessExpired( guess: any ): boolean {
    const status = get( guess, "status", 0 );
    // status 为 2（暂停）或 3（结束）时视为已结束
    return status === 2 || status === 3;
}

export function getActiveGuesses( guesses: any[] ): any[] {
    if ( !Array.isArray( guesses ) ) return [];
    return guesses.filter( guess => !isGuessExpired( guess ) );
}

export function hasActiveGuess( event: any ): boolean {
    return getActiveGuesses( get( event, "guessList", [] ) ).length > 0;
}

// 判断事件是否过期
export function isEventExpired( event: any ): boolean {
    const eventEndTime = get( event, "endTime", 0 );

    if ( eventEndTime === 0 ) {
        return false;
    }

    const now = Date.now();
    return now > eventEndTime;
}
